<template>
    <router-view/>
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if(to.name == 'des-despesa'){
            next({ name: 'des-despesa-list' })
        }else{
            next()
        }
    },
    created() {
        if(this.$route.name == 'des-despesa'){
            this.$router.push({ name: 'des-despesa-list' })
        }
    }
}
</script>
